import { Navigate } from 'react-router-dom';

import { useAuth } from '@alamo/auth';

interface CommissionEligibleRouteProps {
  children: React.ReactNode;
}

/**
 * Gate da self-view "Minhas comissões" (/commissions): passa quem tem
 * consultant_profile elegível a comissão — `consultantType != null &&
 * commissionEligible !== false` (contrato ESCR-commission-clt-scheme).
 *
 * Diferente do ConsultorOnlyRoute (MLM), quem decide aqui é o
 * `commissionEligible` do /auth/me, NÃO o consultantType: CLT recebe comissão
 * pelo esquema por placa (Phase 35) e DEVE acessar /commissions.
 *
 * Redirects:
 *  - admin_alamo → /admin/comissoes/extrato (superfície admin de comissões;
 *    sem consultant_profile o backend responde 403 CONSULTANT_PROFILE_REQUIRED)
 *  - gerente     → /admin/registrations (no dedicated landing yet)
 *  - sem consultant_profile ou commissionEligible === false → /dashboard
 *    (CLT/pf/pj desligado individualmente pelo admin continua sem ver)
 */
export function CommissionEligibleRoute({ children }: CommissionEligibleRouteProps) {
  const { roleName, consultantType, commissionEligible } = useAuth();

  if (roleName === 'admin_alamo') {
    return <Navigate to="/admin/comissoes/extrato" replace />;
  }
  if (roleName === 'gerente') {
    return <Navigate to="/admin/registrations" replace />;
  }
  if (consultantType == null || commissionEligible === false) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
